package net.bothosting.docs.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UndecoratedLinkVariant
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.palette.color
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import net.bothosting.docs.toSitePalette
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Span

@Composable
fun Breadcrumb() {
    val context = rememberPageContext()
    val sitePalette = ColorMode.current.toSitePalette()
    val textColor = ColorMode.current.toPalette().color
    val path = context.route.path

    // Don't show breadcrumb on the home page
    if (path == "/" || path.isEmpty()) return

    // Look up the current page in navStructure
    var sectionTitle: String? = null
    var itemTitle: String? = null
    for (section in navStructure) {
        for (item in section.items) {
            if (item.path == path) {
                sectionTitle = section.title
                itemTitle = item.title
                break
            }
        }
        if (sectionTitle != null) break
    }

    // If we couldn't find it in navStructure, derive from path
    if (sectionTitle == null || itemTitle == null) {
        val parts = path.split("/").filter { it.isNotEmpty() }
        if (parts.size >= 2) {
            sectionTitle = parts[0].replace("-", " ").replace("_", " ")
                .split(" ")
                .joinToString(" ") { it.replaceFirstChar { c -> if (c.isLowerCase()) c.titlecase() else c.toString() } }
            itemTitle = parts[1].replace("-", " ").replace("_", " ")
                .split(" ")
                .joinToString(" ") { it.replaceFirstChar { c -> if (c.isLowerCase()) c.titlecase() else c.toString() } }
        }
    }

    if (sectionTitle == null || itemTitle == null) return

    Row(
        Modifier
            .gap(0.4.cssRem)
            .margin(bottom = 1.5.cssRem)
            .fontSize(0.82.cssRem)
            .styleModifier {
                property("flex-wrap", "wrap")
            },
        verticalAlignment = Alignment.CenterVertically
    ) {
        // Home link
        Link(
            "/",
            variant = UndecoratedLinkVariant,
            modifier = Modifier
                .color(sitePalette.accent)
                .styleModifier { property("text-decoration", "none") }
        ) {
            Span(
                Modifier
                    .fontSize(0.75.cssRem)
                    .color(sitePalette.accent)
                    .toAttrs { attr("class", "fas fa-house") }
            )
        }

        Separator(sitePalette)

        // Section link
        SpanText(
            sectionTitle,
            Modifier
                .color(sitePalette.sidebarText)
                .fontWeight(FontWeight.Medium)
        )

        Separator(sitePalette)

        // Current page (not a link)
        SpanText(
            itemTitle,
            Modifier
                .color(textColor)
                .fontWeight(FontWeight.SemiBold)
        )
    }
}

@Composable
private fun Separator(sitePalette: net.bothosting.docs.SitePalette) {
    Span(
        Modifier
            .fontSize(0.65.cssRem)
            .color(sitePalette.sectionLabel)
            .toAttrs { attr("class", "fas fa-chevron-right") }
    )
}
